<div class="widget-posts widget">
    <h4 class="widget__title">{{ header | translate}}</h4>
    <div class="widget-posts__list">
        <div *ngFor="let post of posts" class="widget-posts__item">
            <div class="widget-posts__image">
                <a [routerLink]="['/blog', post.seo.slug]">
                    <img [src]="post?.thumbImage?.url" alt="">
                </a>
            </div>
            <div class="widget-posts__info">
                <div class="widget-posts__name">
                    <a [routerLink]="['/blog', post.seo.slug]">{{ translateHelper.localize(post.title) }}</a>
                </div>
                <div class="widget-posts__date">{{ post.creationDate | date:"medium" }}</div>
            </div>
        </div>
    </div>
</div>
